import React, { useState } from 'react';
import LibModal from '../../../../features/LibModal/LibModal';
import Button from '../../../../utils/Button';
import { EditIcon, UpdateIcon } from '../../../../utils/SVGIcon';
import cn from '../../../../utils/cn';
import { useBasicSetting } from '../BasicSettingProvider';
import AddSmtpConfigModal from '../Modals/AddSmtpConfigModal';
import SmtpTestMailModal from '../Modals/SmtpTestMailModal';
import UpdateSmtpConfigModal from '../Modals/UpdateSmtpConfigModal';

function BasicInfoSmtp({ formData: { smtpConfig }, title, icon }) {
    const { handleReload } = useBasicSetting();
    const [showSmtpModal, setShowSmtpModal] = useState({ type: '' });
    const closeModalHandler = () => setShowSmtpModal({ type: '' });

    return (
        <div
            className={cn(
                'flex justify-between items-center gap-5 w-full py-3 border-b border-primary-100 overflow-hidden box-border'
            )}
        >
            <div className="flex-initial">
                <div className="size-11 rounded-lg flex items-center justify-center bg-primary-100">
                    {icon}
                </div>
            </div>
            <div className="w-8/12 flex-1">
                <h3 className="text-primary text-base font-medium mb-1">{title || '--'}:</h3>
                <span className="inline-block text-primary font-medium">
                    {smtpConfig?.username || 'Not Configured'}
                </span>
            </div>

            {smtpConfig?.username || smtpConfig?.hostName || smtpConfig?.Password ? (
                <Button
                    title="Test SMTP"
                    className="h-7 md:min-w-min md:py-1 text-sm md:rounded-md "
                    onClick={() => setShowSmtpModal({ type: 'test-smtp-modal' })}
                />
            ) : null}

            {!!smtpConfig?.username || !!smtpConfig?.hostName || !!smtpConfig?.password ? (
                <button
                    type="button"
                    onClick={() => setShowSmtpModal({ type: 'update-smtp-modal' })}
                    className="size-8 p-2 bg-primary-100 rounded-full"
                >
                    <UpdateIcon />
                </button>
            ) : (
                // setup smtp modal
                <button
                    type="button"
                    onClick={() => setShowSmtpModal({ type: 'setup-smtp-modal' })}
                    className="size-8 p-2 bg-primary-100 rounded-full"
                >
                    <EditIcon />
                </button>
            )}

            {/* Setup smtp update modal */}
            {showSmtpModal?.type === 'setup-smtp-modal' && (
                <LibModal title="SMTP Configuration" setOpen={setShowSmtpModal}>
                    <AddSmtpConfigModal
                        closeModalHandler={closeModalHandler}
                        handleReload={handleReload}
                    />
                </LibModal>
            )}

            {/* Update smtp update modal */}
            {showSmtpModal?.type === 'update-smtp-modal' && (
                <LibModal title="SMTP Configuration" setOpen={setShowSmtpModal}>
                    <UpdateSmtpConfigModal
                        data={smtpConfig}
                        closeModalHandler={closeModalHandler}
                        handleReload={handleReload}
                    />
                </LibModal>
            )}

            {/* Show Test SMTP Test Modal */}
            {showSmtpModal?.type === 'test-smtp-modal' && (
                <LibModal title="SMTP Test" setOpen={setShowSmtpModal}>
                    <SmtpTestMailModal
                        data={smtpConfig}
                        handleReload={handleReload}
                        setShowSmtpModal={setShowSmtpModal}
                    />
                </LibModal>
            )}
        </div>
    );
}
export default BasicInfoSmtp;
